var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loan-application"},[_c('Container',{staticClass:"relative"},[_c('Card',{attrs:{"padding":"large"}},[_c('Margins',[_c('CardHeader',{staticClass:"loan-application__card-header",attrs:{"header":_vm.$t('LOAN_APPLICATION')}}),_c('LoanApplicationForm',{staticClass:"margins__triple static"})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }